import React, { useState, useEffect, useMemo } from "react";
import { Formik, Form, FormikHelpers } from "formik";
import * as Yup from "yup";

//MUI
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import FormikControl from "../../components/formik/FormikControl";
import Loader from "../../components/loader/Loader";

import RoleService from "../../services/RoleService";
import { Mode } from "./RolePage";
import { RoleModel } from "../../models/RoleModel";
import { fetchRoles } from "../../redux/actions/RoleActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";

const validationSchema = Yup.object({
  name: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  level: Yup.string().required("Required"),
  // status: Yup.string().required("Required"),
});

type FormProps = Yup.InferType<typeof validationSchema>;

type Props = {
  mode: Mode;
  handleModalClose: () => void;
  data?: RoleModel;
};

const RoleForm = ({ mode, handleModalClose, data }: Props) => {
  const initialValues = useMemo(
    () => ({
      name: "",
      description: "",
      level: "",
      // status: "",
    }),
    []
  );

  const [formState, setFormState] = useState<FormProps>(initialValues);
  const dispatch = useAppDispatch();
  const displayToast = useAppSelector((state) => state.toast.displayToast);

  useEffect(() => {
    if (mode === "edit" && data) {
      setFormState(() => ({
        name: data.name,
        description: data.description,
        level: data.roleLevel,
        // status: data.isActive ? "active" : "inactive",
      }));
    }
  }, [mode, data]);

  const submitHandler = async (
    values: FormProps,
    actions: FormikHelpers<FormProps>
  ) => {
    try {
      let formData: RoleModel = {
        roleId: 0,
        name: "",
        description: "",
        roleLevel: "",
        isActive: true,
        createdDate: new Date(),
        modifiedDate: new Date(),
      };
      if (mode === "add") {
        formData.name = values.name;
        formData.description = values.description;
        formData.roleLevel = values.level;
        // formData.isActive = values.status === "active" ? true : false;
      } else if (data) {
        formData = {
          ...data,
          name: values.name,
          description: values.description,
          roleLevel: values.level,
          // isActive: values.status === "active" ? true : false,
          modifiedDate: new Date(),
        };
      }
      await RoleService.createRole(formData, data?.roleId);
      actions.setSubmitting(false);
      handleModalClose();
      dispatch(fetchRoles());
      displayToast(
        `Role ${mode === "add" ? "created" : "updated"} successfully`,
        "success"
      );
    } catch (error) {
      actions.setSubmitting(false);
    }
  };
  return (
    <Formik
      initialValues={formState}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
      enableReinitialize={true}
    >
      {(formik) => (
        <>
          <Form>
            <Stack gap={2}>
              <FormikControl
                control="input"
                type="text"
                name="name"
                size="small"
                label="Role Name"
                placeholder="Enter Role Name"
              />
              <FormikControl
                control="input"
                multiline
                maxRows={2}
                name="description"
                size="small"
                label="Description"
                placeholder="Enter Description"
              />
              <FormikControl
                control="input"
                type="text"
                name="level"
                size="small"
                label="Role Level"
                placeholder="Enter Role Level"
              />
              {/* <FormikControl
                control="autocomplete"
                options={statusOptions}
                name="status"
                size="small"
                label="Status"
                placeholder="Select Status"
              /> */}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={formik.isSubmitting}
              >
                Submit
              </Button>
            </Stack>
          </Form>
          {formik.isSubmitting && <Loader />}
        </>
      )}
    </Formik>
  );
};

export default RoleForm;
